import * as React from 'react';
import { SVGProps } from 'react';
const SvgAdd = ({
  width = 24,
  height = 24,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="#000"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2834 10.7439V4H10.7834V10.7439L4 10.7429V13.2435L10.7834 13.2446V20H13.2834V13.2446L20 13.2435V10.7429L13.2834 10.7439Z"
      fill="current"
    />
  </svg>
);
export default SvgAdd;
